import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import InvoiceDisplay from '../display/InvoiceDisplay';
import printJS from 'print-js';
import PrintIcon from '@mui/icons-material/Print';

export default function InvoicePreview({ open, onClose, invoice = null }) {
  const handleClose = () => {
    onClose();
  };

  const handlePrint = () => {
    printJS({
      printable: 'print-section', // ID of the element to print
      type: 'html',
      targetStyles: ['*'], // include all CSS styles
    });
  };

  if (!invoice) return null;

  return (
    <Dialog onClose={handleClose} open={open} fullWidth maxWidth="md" disableRestoreFocus>
      <DialogTitle>Invoice Preview</DialogTitle>
      <DialogContent dividers>
        <InvoiceDisplay
          id={invoice.id}
          invoiceNumber={invoice.invoice_number}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handlePrint}>
          <PrintIcon />
        </Button>
        <div style={{ flex: '1 0 0' }} />
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
